export const fitDemoDialogs = (player: HTMLElement) => {
  player.querySelectorAll<HTMLElement>('.demo-dialog').forEach(card => {
    const overlay = card.parentElement
    if (!overlay) return

    const style = getComputedStyle(overlay)
    const verticalPadding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
    const availableHeight = Math.max(0, overlay.clientHeight - verticalPadding)
    const naturalHeight = parseFloat(getComputedStyle(card).height)
    const scale = naturalHeight > availableHeight ? Math.max(0, availableHeight - 1) / naturalHeight : 1
    const value = String(scale)

    if (card.style.getPropertyValue('--demo-dialog-scale') !== value) {
      card.style.setProperty('--demo-dialog-scale', value)
    }
  })
}
